module.exports = __webpack_public_path__ + "assets/images/gym.bc63d0bcdc514f0a349e7b0ba5ba5de8.svg";